module.exports = __webpack_public_path__ + "static/media/thumbnail.2b916fb3.jpg";